import type { components } from '@/generated/internal-api/openapi-types';
import type { ApiID, Entity, ID, ISODateTime } from './Common.model';
import type { MetadataFieldWithValue } from './Metadata.model';
import type { TreatmentGroup } from './TreatmentGroup.model';

export type TreatmentMethod = components['schemas']['TreatmentMethodType'];
export type StudyCreateTreatmentUnitV1 = components['schemas']['StudyCreateTreatmentUnitV1'];

export type StudyTreatment = {
  id: number;
  api_id: TreatmentApiId;
  label: string;
  type: TreatmentMethod;
  in_use: boolean;
};

export interface TreatmentType extends Entity {
  name: string;
  benchling_link: string | null;
  in_use: boolean | null;
  entity_id: string | null;
  registry_id: string | null;
}

export interface TreatmentField {
  name: string;
  label: string;
  default_value?: string | number;
  default_display_value?: string | number;
  required: boolean;
  unit: TreatmentUnit;
}

interface Calculation {
  name: string;
  label: string;
  unit: TreatmentUnit;
  formula: string;
  options?: Array<{
    label: string;
    value: string;
  }>;
}

export type TreatmentCalculation = Calculation | null;

export interface TreatmentUnit {
  id?: ID;
  unit_id: ID;
  display_unit_id: ID;
  display_unit: string | null;
  base_unit: string | null;
  name?: string;
  unit_type?: string;
  base_conversion_formula?: string;
  display_conversion_formula?: string;
}

export type TreatmentApiId = components['schemas']['TreatmentApiId'];
export type TreatmentV1 = components['schemas']['TreatmentV1'];
export type TreatmentFieldV1 = components['schemas']['TreatmentFieldV1'];
export type TreatmentCreateV1 = components['schemas']['TreatmentCreateV1'];
export type ClassificationType = components['schemas']['TreatmentClassification'];

export const ClassificationTypes: { [K in ClassificationType]: K } = {
  treatment: 'treatment',
  pre_treatment: 'pre_treatment',
  disease_induction: 'disease_induction',
} as const;
export type TreatmentVolumeUnit = components['schemas']['TreatmentVolumeUnit'];

export interface Treatment {
  api_id: ApiID<'tmt'>;
  id: ID;
  treatment_label: string;
  name: string;
  treatment_name?: string;
  treatment_id?: ID;
  created_at: ISODateTime;
  updated_at: ISODateTime;
  fields: Array<TreatmentField>;
  calculates: TreatmentCalculation;
  study_groups?: Array<TreatmentGroup>;
  treatment_type: TreatmentType;
  type: TreatmentMethod;
  _duplicate?: boolean;
  temp_id?: string;
  in_use?: boolean;
  metadata?: Array<MetadataFieldWithValue>;
  treatment_classification?: ClassificationType;
  treatment_volume_unit?: TreatmentVolumeUnit;
  benchling_entity_web_url?: string | null;
  benchling_entity_id?: string | null;
  synced_to_benchling?: boolean;
  lock_dosing_inputs?: boolean;
}
